module.exports = __webpack_public_path__ + "img/step2.c7d13e79.png";